const React = require('react');
const PropTypes = require('prop-types');

require('./CustomLegend.scss');

const CustomLegend = props => (
    <div className="tab-profitability__risk-profit-chart__legend">
        {props.payload.map(entry => (
            <span
                className="tab-profitability__risk-profit-chart__legend__entry"
                key={entry.value}
            >
                <i
                    className="icon-radio-check"
                    style={{ color: entry.color }}
                />
                {entry.value}
            </span>
        ))}
    </div>
);

CustomLegend.defaultProps = {
    payload: [],
};

CustomLegend.propTypes = {
    payload: PropTypes.array.isRequired,
};

module.exports = CustomLegend;
